import { render } from "./PaginationNoNumber.vue?vue&type=template&id=31f7c39c"
import script from "./PaginationNoNumber.vue?vue&type=script&lang=js"
export * from "./PaginationNoNumber.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__